export interface EncodedInputV4 {
  seq: number
  inputTick: number
  desiredHeading: number
  boost: boolean
}

export const INPUT_V4_PACKET_SIZE = 12

export function encodeInputV4(input: EncodedInputV4, type = 0x01): ArrayBuffer {
  const buffer = new ArrayBuffer(INPUT_V4_PACKET_SIZE)
  const view = new DataView(buffer)
  view.setUint8(0, type)
  view.setUint16(1, input.seq, true)
  view.setUint32(3, input.inputTick >>> 0, true)
  view.setFloat32(7, input.desiredHeading, true)
  view.setUint8(11, input.boost ? 0x01 : 0x00)
  return buffer
}
